import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import CategoryNavDesk from './CategoryNavDesk';
import CategoryNavMobile from './CategoryNavMobile';
import { breakpoints  } from './../../styles/theme.json';

const CategoryNavWrapperRF = (props) => {
  return (
    <div id={'category-menu-wrapper'}>
      {(props.window_width >= breakpoints.desktop)
        ? <CategoryNavDesk Url={props.cat_page} Navigation={props.cat_nav}/>
        : <CategoryNavMobile Url={props.cat_page} Navigation={props.cat_nav}/>
      }
    </div>
  );
};

export default connect(
  state => ({
    cat_page: state.category_nav_page,
    cat_nav: state.category_nav,
    window_width: state.window_dimensions.window_width
  })
)(CategoryNavWrapperRF);



// WEBPACK FOOTER //
// ./src/components/filter-pages/CategoryNavWrapper.js